import { Button, Text } from '@youversion/design-system-components';
import Spinner from '@youversion/design-system-icons/lib/Spinner';
import React from 'react';

interface Props {
  buttonText?: string;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  testId?: string;
}

export default function Footer({ buttonText, onClick, disabled = false, loading = false, testId }: Props) {
  const handleClick = () => {
    if (!disabled && !loading) {
      onClick?.();
    }
  };

  return (
    <div className='p-2 md:mbs-2 mbs-1 bg-canvas-light dark:bg-canvas-secondary-dark'>
      <Button
        className='justify-center items-center max-w-none'
        data-testid={testId}
        disabled={disabled || loading}
        onClick={handleClick}
        size='md'
        variant='primary'
      >
        {loading ? (
          <Spinner className='animate-spin text-text-light dark:text-text-dark h-3 w-3' />
        ) : (
          <Text className='text-text-dark dark:text-text-light'>{buttonText}</Text>
        )}
      </Button>
    </div>
  );
}
